<div class="container">
  <frg-cards [title]="pageTitle">
    <div class="search-container">
      <div class="search-infos-wrapper">
        <frg-form-input id="plainText" type="text" label="Titre documents" [formGroup]="formGroup"
          [control]="formGroup.get('plainText')"></frg-form-input>
      </div>
      <div class="button-wrapper">
        <frg-button (activated)="searchDocuments(true)">Rechercher</frg-button>
      </div>
    </div>
    <div class="results-container">
      <!-- Message d'état vide -->
      <div class="empty-state"
        *ngIf="isInitOver && (!documentsTable || !documentsTable.objects || documentsTable.objects.length === 0)">
        <div class="empty-state-icon">
          <mat-icon>description</mat-icon>
        </div>
        <h3 class="empty-state-title">Aucun document trouvé</h3>
        <p class="empty-state-message">
          Vous n'avez pas encore ajouté de documents personnels.<br>
          Cliquez sur le bouton ci-dessous pour ajouter un document.
        </p>
        <app-import-documents #importDocumentsComponent [isUserDocument]="true" (importOver)="importOverFnc()">
        </app-import-documents>
      </div>
      <!-- Liste des documents -->
      <div *ngIf="isInitOver && documentsTable && documentsTable.objects && documentsTable.objects.length > 0">
        <!-- Bouton d'import -->
        <div class="import-button-container">
          <app-import-documents #importDocumentsComponent [isUserDocument]="true" (importOver)="importOverFnc()">
          </app-import-documents>
        </div>
        <!-- Tableau des documents -->
        <table mat-table [dataSource]="dataSource" matSort class="mat-table">
          <!-- Colonne Titre -->
          <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Titre </th>
            <td mat-cell *matCellDef="let row"> {{row.title}} </td>
          </ng-container>
          <!-- Colonne Taille -->
          <ng-container matColumnDef="formatFileSize">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Taille </th>
            <td mat-cell *matCellDef="let row"> {{row.formatFileSize}} </td>
          </ng-container>
          <!-- Colonne Date de création -->
          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Date de création </th>
            <td mat-cell *matCellDef="let row"> {{row.createdAt}} </td>
          </ng-container>
          <!-- Colonne Actions -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Actions </th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="downloadDocument(row)">
                  <mat-icon>download</mat-icon>
                  <span>Télécharger</span>
                </button>
                <button mat-menu-item (click)="renameDocument(row)">
                  <mat-icon>edit</mat-icon>
                  <span>Renommer</span>
                </button>
                <button mat-menu-item (click)="deleteDocument(row)">
                  <mat-icon>delete</mat-icon>
                  <span>Supprimer</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" (dblclick)="openDocument(row)"></tr>
        </table>
        <mat-paginator [length]="documentsTable?.total" [pageSize]="_tableFiltre.perpage"
          [pageSizeOptions]="[5, 10, 25, 50]" (page)="changePage($event)"></mat-paginator>
      </div>
    </div>
  </frg-cards>
</div>